import { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { IonHeader, IonIcon, IonSpinner } from "@ionic/react";
import { NavLink } from "react-router-dom";
import Page from "../../components/Page";
import { chevronBackOutline, chevronForwardOutline, chevronDownOutline } from "ionicons/icons";
import { bindActionCreators } from "@reduxjs/toolkit";
import * as CartActions from "../../actions/CartActions";
import { connect } from "react-redux";
import { QuantityManager } from "../../components/QuantityManager";
import { DISH_MODES } from "../../constants/DishConstants";
import { setMiscDishData } from "../../actions/DishActions";
import { setUserData } from "../../actions/UserActions";
import * as XookActions from "../../actions/XookActions";
import * as FoodActions from "../../actions/FoodActions";
import withNav from "../../utils/hoc/withNav";
import OrderService from "../../services/OrderService";
import UserService from "../../services/UserService";
import { deepCopy, isEmptyObject } from "../../utils/objects";
import ToastService from "../../services/ToastService";
import FoodService from "../../services/FoodService";
import {
	Modal,
	ModalSubtitle,
	ModalButtonGroup,
	ModalPrimaryButton,
	ModalOverlay,
	ModalHeader,
	ModalSecondaryButton,
} from "../../components/Modal";
import { getRandomInt, precision, uptilTwoDecimalPlaces } from "../../utils/misc";
import { calculateInventory, validateCartItems } from "../../utils/parsers/inventory";
import { setInitalInventory, updateIngrdientQuantity } from "../../actions/InventoryActions";
import { INVENTORY_UPDATE_ACTION } from "../../constants/InventoryConstants";
import ErrorComponent from "../../components/Error";
import useIsAppOffline from "../../utils/hooks/useIsOffline";
import { SPECIAL_ERRORS } from "../../config/error";
import Analytics, { TRACK_PAGE_CATEGORIES } from "../../lib/anayltics";
import ToolTip from "../../components/ToolTip";
import { renderDishContents } from "../../utils/parsers/dishContents";
import BottomCTA from "../../components/BottomCTA";
import { handleCheckout } from "../../services/CheckoutService";
import { SecondaryTextBright } from "../../components/Texts";
import OrderPickupTimeModal, { handleOrderPickupTime } from "./components/OrderPickupTime";

const Center = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;
	width: 100%;
`;

const Error = styled.div`
	font-weight: 600;
	font-size: 20px;
	color: #fff;
	width: 100%;
`;

const PageHeader = styled(IonHeader)`
	position: fixed;
	margin: 0 0 0 0;
	background: ${({ theme }) => theme.colors.main.background};
	color: #f2f2f2;
	font-style: normal;
	font-size: 20px;
	display: flex;
	align-items: center;
	padding: 1.5rem 1rem;
	border: none;
	box-shadow: none;
	&:after {
		background-image: none;
	}
`;

const BackButton = styled(NavLink)`
    margin: 2px 0.5rem 0 -5px;
}
`;

const BackButtonImg = styled(IonIcon)`
	width: 24px;
	height: 24px;
	color: #fff;
`;

const PageTitle = styled.div`
	font-style: normal;
	font-weight: 500;
	font-size: 20px;
	letter-spacing: 0px;
	display: flex;
	justify-content: center;
`;

// const HelpButton = styled(IonIcon)`
//     width: 20px;
//     height: 20px;
//     margin-left:auto;
// `;

const RestoName = styled.div`
	color: #f2f2f2;
	margin-left: auto;
	font-size: 14px;
`;

const PaddedElement = styled.div`
	margin: 5rem 0 0 0;
`;

const SmallPaddedElement = styled.div`
	margin: 1.7rem 0 0 0;
`;

const Header = styled.div<any>`
	margin: ${(props) => props.margin};
	text-align: left;
	font-weight: 500;
	font-size: 18px;
	color: #fff;
	width: 100%;
`;

const SubHeader = styled.div<any>`
	margin: ${(props) => props.margin};
	text-align: left;
	font-weight: 500;
	font-size: 16px;
	color: #fff;
	width: 100%;
`;

const Subtitle = styled.div`
	color: #d6d6d6;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
`;

const BrandName = styled.div`
	color: #e8e8e8;
	text-align: left;
	font-size: 18px;
	font-weight: 600;
	line-height: normal;
`;

const BrandLogo = styled.div`
	display: flex;
	padding: 0 1rem 0 0;
	align-self: flex-start;
`;

const BrandLogoImg = styled.img`
	width: 42px;
	height: 42px;
	border-radius: 4px;
`;

const Dish = styled.div<any>`
	display: flex;
	flex-direction: column;
	align-self: stretch;
	height: max-content;
	padding: 1rem 0;
	color: #f2f2f2;
	position: relative;
	${(props) =>
		props.disabled &&
		css`
			opacity: 0.4;
		`}
	&:not(:first-child) {
		border-top: 1px solid #ffffff50;
	}
`;

const ExpandArrow = styled(IonIcon)`
	width: 18px;
	height: 18px;
`;

const DishData = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	min-width: 0;
	height: max-content;
`;

const DishHead = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: 1rem;
`;

const DishTitle = styled.div`
	font-size: 18px;
	font-weight: 500;
	text-align: left;
	line-height: 22px;
`;

const Line = styled.div`
	height: 4px;
	width: 25px;
	background: #ffcc00;
`;

const CustomizeLink = styled.div`
	font-weight: 500;
	font-size: 15px;
	text-decoration: underline;
	text-underline-offset: 2px;
	color: #e8e8e8;
`;

const OfferCard = styled.div`
	margin: 1rem 0 0 0;
	padding: 1rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	align-self: stretch;
	height: max-content;
	border-radius: 8px;
	color: #f2f2f2;
	background: #4B4B4B;
	border-radius: 6px;
`;

const OfferCardText = styled.div`
	font-weight: 700;
	font-size: 16px;
`;

const OfferCartArrow = styled(IonIcon)`
	font-size: 30px;
	--ionicon-stroke-width: 10px;
`;

const CouponsCard = styled.div<any>`
	background: #4B4B4B;
	height: max-content;
	width: 100%;
	display: flex;
	flex-direction: column;
	border-radius: 6px;
	margin: 1rem 0 0 0;
	padding: 0 1rem;
`;

const CouponContainer = styled.div`
	padding: 1rem 0;
	width: 100%;
	display: flex;
	flex-direction: column;
	height: max-content;
	color: #0a3d08;
	background: #4B4B4B;
	&:not(:first-child) {
		border-top: 1px dotted #f2f2f2;
	}
`;

const CouponContent = styled.div`
	display: flex;
	flex-direction: column;
`;

const CouponDetails = styled.div`
	display: flex;
	text-align: left;
	width: 100%;
	justify-content: space-between;
`;

const CouponTitle = styled.div`
	color: #e8e8e8;
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
`;

const CouponSubTitle = styled.div`
	margin: 0.3rem 0 0 0;
	color: #d6d6d6;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
`;

const CouponAction = styled.div<any>`
	margin: 0.4rem 0 0 0;
	text-align: right;
	font-size: 12px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	color: #ffcc00;
`;

const CouponFooter = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	margin: 0.8rem 0 0 0;
`;

const CouponLinks = styled.div`
	color: #f2f2f2;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	text-decoration: underline;
`;

const CouponLinksArrow = styled(IonIcon)`
	color: #f2f2f2;
	font-size: 15px;
	margin: 0.1rem 0 0 0.25rem;
`;

const BillCard = styled.div`
	margin: 1rem 0 0 0;
	gap: 0.5rem 0;
	width: 100%;
	padding: 1rem;
	display: flex;
	flex-direction: column;
	align-items: center;
	height: max-content;
	background: #4B4B4B;
	border-radius: 6px;
`;

const InfoCard = styled(BillCard)`
	line-height: 1.2rem;
`

const CheckoutItemCount = styled.span`
	font-weight: 500;
	font-size: 16px;
	text-transform: none;
`;

const CheckoutSeperator = styled.div`
	border-left: 1px solid #000;
	height: 20px;
`;

const CheckoutPrice = styled.span`
	font-weight: 500;
	font-size: 16px;
`;

const ProceedText = styled.span`
	font-weight: 600;
	font-size: 20px;
	text-transform: uppercase;
`;

const Row = styled.div<any>`
	display: flex;
	justify-content: ${(props) => props.jContent || "space-between"};
	align-items: center;
	width: ${(props) => props.width || "100%"};
	padding: ${(props) => props.padding};
	gap: ${(props) => props.gap};
	margin: ${(props) => props.margin || "0 0 0 0"};
`;

const Column = styled.div<any>`
	display: flex;
	flex-direction: column;
	justify-content: ${(props) => props.jContent};
	width: ${(props) => props.width || "100%"};
	height: ${(props) => props.height};
	padding: ${(props) => props.padding};
	gap: ${(props) => props.gap};
	margin: ${(props) => props.margin || "0rem 0 0 0"};
	transition: 300ms all ease-in-out;
`;

const DishHeadColumn = styled(Column)`
	gap: 12px;
	flex: 1;
	width: unset;
	justify-content: space-between;
`;

const BillingContent = styled.div<any>`
	display: flex;
	flex-direction: row;
	align-items: center;
	color: #e8e8e8;
	font-size: 14px;
	font-weight: 500;
	line-height: normal;
	width: max-content;
	height: max-content;
	margin: ${(props) => props.margin};
	padding: ${(props) => props.padding};
`;

const BillingSubContent = styled.div`
	color: #d6d6d6;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
`;

const Seperator = styled.div<any>`
	border-top: 1px dotted #f2f2f2;
	width: 100%;
	margin: ${(props) => props.margin || "0.5rem 0"};
`;

const DiscountedPrice = styled.div<any>`
	font-weight: 400;
	font-size: 14px;
	color: #f2f2f2;
	text-decoration: line-through;
`;

const CartItemsCard = styled.div<any>`
	background: #4B4B4B;
	height: max-content;
	width: 100%;
	display: flex;
	flex-direction: column;
	border-radius: 6px;
	margin: 1rem 0 0 0;
	padding: 0 1rem;
	${(props) =>
		props.invalid &&
		css`
			background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23D6D6D640' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
			border-radius: 4px;
		`}
`;

const HighLightedText = styled.span`
	color: #fff !important;
	text-decoration: underline;
`;

// Removed unused ClockIcon after replacing clock row with Milestone component

const cardExpandedClass = "card-expanded";
const cardHideClass = "card-hide";
const cardArrowExpandedClass = "card-expanded-arrow";
const arrowIdSuffix = "-arrow";

const cartAddDisabledError =
	"We regret to inform you that we currently do not have enough stock to fulfill your request. Please consider adjusting the quantity or try again later.";

const Cart = (props: any) => {
	const { kioskId } = props.match.params;

	//Redux States

	const { Xook, Food, Inventory, User, Cart: CartStates } = props;

	const {
		cartItems,
		cartPrice,
		itemsCount,
		taxEntity,
		totalSaving,
		offers,
		finalCartPrice,
		invalidCartItems,
		isCartValid,
		showDiscardedItemsError,
		discardedCart,
		brandDetails,
	} = CartStates;

	const { xookId, dataLoaded, maxItemsPerOrder, currency } = Xook;

	const { dishDetails, recipesMap, menuData, ingredientDetails } = Food;

	const { initialInventory, availableItems } = Inventory;

	const { dietaryPreferences } = User;

	//Redux Actions
	const {
		navigate,
		setMiscDishData,
		setCart,
		setXookServingData,
		storeXookData,
		storeFoodData,
		setUserData,
		setInitalInventory,
		updateIngrdientQuantity,
		storeDynamicData,
		updateDiscardedCart,
		softUpdateCart,
	} = props;

	//Component States
	const [componentsLoading, setComponentsLoading] = useState<any>([]);
	const [error, setError] = useState(false);
	const [loading, setLoading] = useState<boolean>(!dataLoaded);
	const [buttonLoading, setButtonLoading] = useState<any>(false); //TODO: FIX THIS.
	const [showInventoryErrorModal, setInventoryErrorModal] = useState(false);
	const [errorCode, setErrorCode] = useState<any>();
    const [orderPickupData, setOrderPickupData] = useState<any>("");
	const [invalidCartModal, showInvalidCartModal] = useState(false);
	const [invalidCartMessage, setInvalidCartMessage] = useState("");
	const [unAvailableCart, showUnavailableCart] = useState(false);
	const [unavailableCartMessage, setUnavailableCartMessage] = useState("");
	const [recitifiedCart, setRectifiedCart] = useState<any>(null);
	const [createOrderLoading, setCreateOrderLoading] = useState(false);
	const [createOrderError, setCreatOrderError] = useState("");
	const [errorModal, showErrorModal] = useState(false);
	const [orderPickupTimeModal, showOrderPickupTimeModal] = useState<boolean>(false);

	const isAppOffline = useIsAppOffline();

	useEffect(() => {
		onPageLoad();
	}, []);

	function onPageLoad() {
		Analytics.trackPage(TRACK_PAGE_CATEGORIES.PAGE_LOAD, "Cart");
		//Wait for every data to be set in redux before setting loading as false.

		let waitFor = [];
		if (!dataLoaded) {
			let promise = getDataAndValidate();
			waitFor.push(promise);
		}
		Promise.all(waitFor)
			.then(() => setLoading(false))
			.catch((err) => {
				console.log(err);
				setLoading(false);
			});
	}

	useEffect(() => {
		if (isAppOffline) {
			setErrorCode(SPECIAL_ERRORS.NETWORK_ERROR);
			setError(true);
		} else if (!isAppOffline && errorCode === SPECIAL_ERRORS.NETWORK_ERROR) {
			setError(false);
			setErrorCode(null);
			setLoading(true);
			onPageLoad();
		}
	}, [isAppOffline]);

	function getDataAndValidate() {
		//Have to wait for both static data and cart data to be available to allocate inventory for current cart items.

		const staticDataPromise = getStaticData(kioskId);
		const dynamicDataPromise = getDynamicData(kioskId);
		const cartDataPromise = getUserPreferences(kioskId);

		Promise.all([staticDataPromise, dynamicDataPromise, cartDataPromise])
			.then((responses) => {
				if (responses[0] && responses[1] && responses[2]) {
					const { recipesMap, availableItems } = responses[1];
					const { cartData } = responses[2];

					//Set inital inventory to check sold out states with.

					setInitalInventory({ availableItems });

					//Allocate inventory for cartItems
					if (cartData?.cartItems?.length) {
						const { isCartValid, invalidCartItems } = validateCartItems({ cartItems:cartData.cartItems, recipesMap, availableItems });
						const calculateOnlyFor = cartData.cartItems.filter((cartItem:any, index:any) =>  !invalidCartItems.includes(index + "") );
						const { quantityRequired } = calculateInventory({ cartPayload: { cartItems:calculateOnlyFor }, recipesMap });

						updateIngrdientQuantity({ inventoryPayload: quantityRequired, mode: INVENTORY_UPDATE_ACTION.REMOVE });

						setCart({ isCartValid, invalidCartItems, ...cartData });
					}

					storeXookData({ dataLoaded: true });
				}
			})
			.catch((err) => {
				console.log(err);
				setLoading(false);
				setError(true);
			});
	}

	async function getStaticData(kioskId: string) {
		const response = await FoodService.getStaticData(kioskId);
		const { data, error } = response;
		if (data) {
			const { restaurantDetails, currencySymbols, ...foodData } = data;
			storeXookData({ ...restaurantDetails, currencySymbols, xookId: kioskId });
			storeFoodData(foodData);
			return { currencySymbols };
		}
		if (error) {
			setError(error);
			return false;
		}
		return false;
	}

	async function getDynamicData(kioskId: string) {
		const response = await FoodService.getDynamicFoodData(kioskId);
		const { data, error } = response;
		if (data) {
			const { statusData, pricingMap, availableItems, ...rest } = data;
			const { menuData, recipesMap } = rest;
			const { currencySymbol } = menuData;
			setXookServingData(statusData);
			setInitalInventory({ availableItems });
			storeDynamicData(rest);
			storeXookData({ pricingMap, currency: currencySymbol });
			return { recipesMap, availableItems };
		}
		if (error) {
			setError(error);
			return false;
		}
		return false;
	}

	async function getUserPreferences(kioskId: string) {
		const response = await UserService.getUserPreferences();
		const { data, error } = response;
		if (data) {
			const { cartData, ...rest } = data;
			const activeKioskCartData = cartData?.[kioskId];
			setUserData(rest);
			if (activeKioskCartData) {
				return { cartData: activeKioskCartData };
			} else {
				return { cartData: {} };
			}
		}
		if (error) {
			setError(error);
			return false;
		}
	}

	//Update Cart Item Quantity
	function createCartPayload(mode: string, index: any) {
		const { quantity, price } = cartItems[index];
		let newItem = deepCopy(cartItems[index]);
		let newQuantity = quantity;
		let newCartItems = deepCopy(cartItems);
		let newItemsCount = deepCopy(itemsCount);
		let itemPrice = price;

		switch (mode) {
			case "INCREMENT":
				newQuantity++;
				newItemsCount++;
				break;

			case "DECREMENT":
				newQuantity--;
				newItemsCount--;
				break;
		}

		if (newQuantity < 0) {
			return;
		} else if (newQuantity === 0) {
			newItem.quantity = newQuantity;
			newCartItems[index] = newItem;
		} else {
			newItem.price = precision(itemPrice, 2);
			newItem.quantity = newQuantity;
			newCartItems[index] = newItem;
		}

		//Cart Payload
		return {
			cart: {
				cartPrice: precision(cartPrice, 2),
				cartItems: newCartItems,
				itemsCount: newItemsCount,
				offers,
			},
		};
	}

	//Update Cart Call
	async function updateCart(index: any, mode: any) {
		if (mode === "INCREMENT") {
			const newItemsCount = itemsCount + 1;
			//Check for Max Items allowed per order
			if (newItemsCount > maxItemsPerOrder) {
				//Show Error
				setComponentsLoading((prev: any) => prev.filter((cartIndex: any) => cartIndex !== index));
				ToastService.showToast("Max Cart Quantity Reached");
				return;
			}

			//Increment the quantity and check if it's valid.
			const cartItemWithNewQuantity = { ...cartItems[index], quantity: 1 };

			const { isCartValid } = validateCartItems({ cartItems: [cartItemWithNewQuantity], availableItems, recipesMap });

			if (!isCartValid) {
				setComponentsLoading((prev: any) => prev.filter((cartIndex: any) => cartIndex !== index));
				ToastService.showToast(cartAddDisabledError);
				return;
			}
		}

		const cartPayload = createCartPayload(mode, index);
		setComponentsLoading((prev: any) => [...prev, index]);
		const response = await OrderService.addToCart(cartPayload, xookId);
		const { data, error } = response;
		if (data) {
			//Set updatedCart
			const { newCart, discardedCart } = data;

			let showDiscardedItemsError = false;

			if (discardedCart?.cartItems?.length) {
				//Show Error
				showDiscardedItemsError = true;
			}

			//Validate Cart on every change
			const { isCartValid, invalidCartItems } = validateCartItems({
				cartItems: newCart.cartItems,
				recipesMap,
				availableItems: initialInventory,
			});
			//Filter out valid items
			const calculateOnlyFor = newCart.cartItems.filter((cartItem: any, index: any) => !invalidCartItems.includes(index + ""));
			//Calculate inventory for only valid items.
			const { quantityRequired } = calculateInventory({ cartPayload: { cartItems: calculateOnlyFor }, recipesMap });
			//Update inventory accordingly
			updateIngrdientQuantity({ inventoryPayload: quantityRequired, mode: INVENTORY_UPDATE_ACTION.REMOVE_FROM_INITIAL });

			let cartUpdatedPayload = { ...newCart, invalidCartItems, isCartValid, showDiscardedItemsError, discardedCart };
			setCart(cartUpdatedPayload);
		}
		if (error) {
			ToastService.showToast("Something Went Wrong");
		}

		setComponentsLoading((prev: any) => prev.filter((cartIndex: any) => cartIndex !== index));
	}

	function expandDishPriceDetails(id: string) {
		const dishPricingSection = document.getElementById(id);
		const dishPricingArrow = document.getElementById(id + arrowIdSuffix);
		if (dishPricingSection && dishPricingArrow) {
			const alreadyExpanded = dishPricingSection.classList.contains(cardExpandedClass);
			if (alreadyExpanded) {
				dishPricingSection.classList.add(cardHideClass);
				dishPricingSection.classList.remove(cardExpandedClass);
				dishPricingArrow.classList.remove(cardArrowExpandedClass);
			} else {
				dishPricingSection.classList.remove(cardHideClass);
				dishPricingSection.classList.add(cardExpandedClass);
				dishPricingArrow.classList.add(cardArrowExpandedClass);
			}
		}
	}

	function renderCouponsForCartItems(offers: any, quantity: number, componentId: string = "") {
		let renderData = [];

		for (const offerGroup in offers) {
			const offerGroupData = offers[offerGroup];
			for (const offer in offerGroupData) {
				const { savingPerItem, offerCode, title } = offerGroupData[offer] || {};
				renderData.push(
					<Row margin="0.5rem 0 0 0">
						<BillingSubContent>{title || offerCode}</BillingSubContent>
						<BillingSubContent>
							{currency} {uptilTwoDecimalPlaces(savingPerItem * quantity)}
						</BillingSubContent>
					</Row>
				);
			}
		}

		if (!renderData.length) return;

		return (
			<Column padding="0" id={componentId} className={cardHideClass}>
				{renderData}
			</Column>
		);
	}

	function renderCartItems() {
		let renderData: any = [],
			cartItemsData: any = [],
			discardItemsData: any = [];
		if (!dataLoaded) return;
		if (cartItems?.length) {
			const brandData = brandDetails?.[0];
			if (brandData) {
				const { brandCms, brandName } = brandData;
				renderData.push(
					<Row jContent="flex-start">
						<BrandLogo>
							<BrandLogoImg src={brandCms?.brandLogo || ""} />
						</BrandLogo>
						<Column width="max-content" jContent="space-between" height="100%">
							<BrandName>{brandName}.</BrandName>
							<Subtitle>You have {itemsCount} item (s)</Subtitle>
						</Column>
					</Row>
				);
			}

			//Render CartItems
			cartItems.forEach((cartItem: any, index: any) => {
				const { dishId, quantity, price, segments, brandId, totalCalories, allergens, offeredPrice, offerAppliedPrice, offers } =
					cartItem;
				const isCartItemInvalid = invalidCartItems.includes(index + "");
				const dishDataStatic = dishDetails?.[dishId];
				//If no static data found don't render dish
				if (!dishDataStatic) {
					return;
				}
				const { title } = dishDataStatic;

				const isLoading = componentsLoading.includes(index);
				const hasOffers = !isEmptyObject(offers?.coupons) || !isEmptyObject(offers?.discounts);

				//Handle Customize Dish Click
				const customizeDish = () => {
					const linkToCustomize = `/kiosk/${xookId}/${brandId}/dish/${dishId}?mode=${DISH_MODES.CUSTOMIZE}`;
					const itemCustomizePayload = {
						cartIndex: index,
						customizedSegments: segments,
						quantity,
						totalCalories,
						totalDishPrice: price,
					};
					setMiscDishData(itemCustomizePayload);
					navigate.push(linkToCustomize, "backward");
				};

				const componentId = getRandomInt().toString();

				cartItemsData.push(
					<Dish disabled={isCartItemInvalid}>
						<Row margin="0">
							<DishData>
								<DishHead>
									<DishHeadColumn>
										<DishTitle>{title}</DishTitle>
										<Line />
									</DishHeadColumn>
									<QuantityManager
										disableAdd={isCartItemInvalid}
										errorMessage={cartAddDisabledError}
										value={quantity}
										isLoading={isLoading}
										incrementer={() => {
											updateCart(index, "INCREMENT");
										}}
										decrementer={() => {
											updateCart(index, "DECREMENT");
										}}
									/>
								</DishHead>
								<Column margin="1.5rem 0 0 0" gap="0.5rem">
									<SecondaryTextBright>Ingredients</SecondaryTextBright>
									{renderDishContents({ dishData: cartItem, allergens, dietaryPreferences })}
								</Column>
							</DishData>
						</Row>
						<Row margin="1rem 0 0 0" onClick={() => expandDishPriceDetails(componentId)}>
							<BillingContent>
								<CustomizeLink onClick={customizeDish}>Customize</CustomizeLink>
							</BillingContent>
							<BillingContent>
								{typeof offeredPrice !== "undefined" || typeof offerAppliedPrice !== "undefined" ? (
									<>
										<DiscountedPrice>
											{currency} {uptilTwoDecimalPlaces(price * quantity)}
										</DiscountedPrice>
										&nbsp; {currency} {uptilTwoDecimalPlaces((offeredPrice || offerAppliedPrice) * quantity)}
									</>
								) : (
									<>
										&nbsp; {currency} {uptilTwoDecimalPlaces(price * quantity)}
									</>
								)}
								{hasOffers ? (
									<>
										&nbsp; <ExpandArrow src={chevronDownOutline} id={`${componentId}${arrowIdSuffix}`} />
									</>
								) : (
									""
								)}
							</BillingContent>
						</Row>
						{renderCouponsForCartItems(offers, quantity, componentId)}
					</Dish>
				);
			});

			renderData.push(<CartItemsCard>{cartItemsData}</CartItemsCard>);
		}

		if (discardedCart?.cartItems?.length) {
			const { cartItems } = discardedCart;

			renderData.push(<Header margin="1rem 0 0 0">Discarded Items</Header>);

			cartItems.forEach((cartItem: any, discardedCartIndex: any) => {
				const { dishId, quantity, price, allergens, offeredPrice, offerAppliedPrice } = cartItem; //handling both offeredPrice and  offerAppliedPrice for backward compatibility
				const dishDataStatic = dishDetails?.[dishId];
				//If no static data found don't render dish
				if (!dishDataStatic) {
					return;
				}
				const { title } = dishDataStatic;

				function removeFromDiscarded() {
					const newDiscardedItems = cartItems.filter((_: any, index: any) => index !== discardedCartIndex);
					updateDiscardedCart({ cartItems: newDiscardedItems });
				}

				discardItemsData.push(
					<Dish disabled={true}>
						<Row margin="0">
							<DishData>
								<DishHead>
									<DishHeadColumn>
										<DishTitle>{title}</DishTitle>
										<Line />
									</DishHeadColumn>
									<QuantityManager disableAdd={true} decrementer={removeFromDiscarded} value={quantity} />
								</DishHead>
								{renderDishContents({ dishData: cartItem, allergens, dietaryPreferences })}
							</DishData>
						</Row>
						<Seperator margin={"1rem 0 0.5rem 0"} />
						<Row>
							<BillingContent>Price Details </BillingContent>
							<BillingContent>
								{typeof offeredPrice !== "undefined" || typeof offerAppliedPrice !== "undefined" ? (
									<>
										<DiscountedPrice>
											{currency} {uptilTwoDecimalPlaces(price * quantity)}
										</DiscountedPrice>
										&nbsp; {currency} {uptilTwoDecimalPlaces((offeredPrice || offerAppliedPrice) * quantity)}
									</>
								) : (
									<>
										&nbsp; {currency} {uptilTwoDecimalPlaces(price * quantity)}
									</>
								)}
							</BillingContent>
						</Row>
					</Dish>
				);
			});

			renderData.push(<CartItemsCard invalid={true}>{discardItemsData}</CartItemsCard>);
		}

		if (dataLoaded && !discardedCart?.cartItems?.length && !cartItems?.length) {
			renderData.push(
				<Center>
					<Error>Your Cart is Empty</Error>
				</Center>
			);
		} else if (itemsCount < maxItemsPerOrder) {
			renderData.push(
				<SubHeader onClick={() => navigate.push(`/kiosk/${xookId || kioskId}`)} margin="1.5rem 0 0 0">
					<HighLightedText>+ Add more items</HighLightedText>
				</SubHeader>
			);
		}

		return renderData;
	}

	async function removeCoupon(removedCouponId: string) {
		setComponentsLoading((prev: any) => [...prev, removedCouponId]);
		const payload = { removedCouponId, menuId: menuData?.id };
		const { data, error } = await UserService.removeCoupon(kioskId, payload);
		setComponentsLoading((prev: any) => prev.filter((component: any) => component !== removedCouponId));
		if (data) {
			const { cart } = data;
			setCart(cart);
		}
		if (error) {
			ToastService.showToast(error);
		}
	}

	function navigateToCouponsPage() {
		navigate.push(`/kiosk/${kioskId}/coupons`);
	}

	function renderActiveCoupons() {
		let renderData = [],
			couponsRenderData = [];
		if (itemsCount) {
			renderData.push(<Header>Coupons</Header>);

			if (offers?.coupons && !isEmptyObject(offers?.coupons)) {
				const { coupons } = offers;

				for (const couponId in coupons) {
					const { saving, offerCode, title } = coupons[couponId] || {};
					const isLoading = componentsLoading.includes(couponId);
					couponsRenderData.push(
						<CouponContainer>
							<CouponDetails>
								<CouponContent>
									<CouponTitle>{title || offerCode}</CouponTitle>
									<CouponSubTitle>{`Get ${currency}${saving} off on this order`}</CouponSubTitle>
								</CouponContent>
								{isLoading ? (
									<IonSpinner name="dots" />
								) : (
									<CouponAction onClick={() => removeCoupon(couponId)}>Remove</CouponAction>
								)}
							</CouponDetails>
						</CouponContainer>
					);
				}

				renderData.push(<CouponsCard>{couponsRenderData}</CouponsCard>);

				renderData.push(
					<CouponFooter onClick={navigateToCouponsPage}>
						<CouponLinks>View other coupons</CouponLinks>
						<CouponLinksArrow src={chevronForwardOutline} />
					</CouponFooter>
				);
			} else {
				renderData.push(
					<OfferCard onClick={navigateToCouponsPage}>
						<OfferCardText>View Coupons</OfferCardText>
						<OfferCartArrow src={chevronForwardOutline}></OfferCartArrow>
					</OfferCard>
				);
			}
		}
		return renderData;
	}

	function renderBilling() {
		if (cartItems?.length) {
			let renderData: any = [];
			let cartOffersData: any = [];

			for (const offerGroup in offers) {
				for (const cartOffer in offers[offerGroup]) {
					const { saving, offerCode, title } = offers[offerGroup][cartOffer];
					cartOffersData.push(
						<Row>
							<BillingSubContent>{title || offerCode}</BillingSubContent>
							<BillingSubContent>
								{currency}
								{uptilTwoDecimalPlaces(saving)}
							</BillingSubContent>
						</Row>
					);
				}
			}

			renderData.push(<Header>Bill Details</Header>);
			renderData.push(
				<BillCard>
					<Row>
						<BillingContent>Cart Total</BillingContent>
						<BillingContent>
							{currency}
							{uptilTwoDecimalPlaces(cartPrice)}
						</BillingContent>
					</Row>
					{typeof totalSaving !== "undefined" ? (
						<Row>
							<BillingContent>Discount</BillingContent>
							<BillingContent>
								{currency}
								{uptilTwoDecimalPlaces(totalSaving)}
							</BillingContent>
						</Row>
					) : (
						""
					)}
					{cartOffersData}
					{taxEntity?.platformFees ? (
						<Row>
							<BillingContent>
								Platform Fees &nbsp;
								<ToolTip
									message={`This will be applied only when the final order value is in between ${currency}0.00 and ${currency}0.50 `}
								/>
							</BillingContent>
							<BillingContent>
								{currency} {uptilTwoDecimalPlaces(taxEntity?.platformFees)}
							</BillingContent>
						</Row>
					) : (
						""
					)}
					{taxEntity?.platformFeesTaxAmount ? (
						<Row>
							<BillingContent>Platform Fees Tax</BillingContent>
							<BillingContent>
								{currency} {uptilTwoDecimalPlaces(taxEntity?.platformFeesTaxAmount)}
							</BillingContent>
						</Row>
					) : (
						""
					)}
					<Row>
						<BillingContent>Tax</BillingContent>
						<BillingContent>{`${currency}${uptilTwoDecimalPlaces(taxEntity?.taxAmount)}`}</BillingContent>
					</Row>
					<Seperator />
					<Row>
						<BillingContent>To Pay</BillingContent>
						<BillingContent>
							{currency}
							{uptilTwoDecimalPlaces(finalCartPrice)}
						</BillingContent>
					</Row>
				</BillCard>
			);
			return renderData;
		}
	}

    function computeAndSetOrderPickupData(pickupTime: any, totalPreparationTime: any) {
        const data = handleOrderPickupTime(pickupTime, totalPreparationTime);
        setOrderPickupData(data);
    }

	async function getOrderStartTime() {
		setButtonLoading(true);
		const response = await OrderService.getOrderStartTime(kioskId);
		const { data, error } = response;
		if (data) {
            const { busyTill, totalPreparationTime } = data;
            computeAndSetOrderPickupData(busyTill, totalPreparationTime);
			setButtonLoading(false);
			showOrderPickupTimeModal(true);
		}
		if (error) {
			setButtonLoading(false);
			ToastService.showToast("Something went wrong!");
		}
	}

	//Create Order Call
	async function createOrder() {
		setCreateOrderLoading(true);
		const createOrderPayload = {
			restaurantId: xookId,
			paymentMetaData: {
				successUrl: window.location.origin + `/kiosk/${xookId}/order/status/`,
				cancelUrl: window.location.origin + `/kiosk/${xookId}/cart`,
			},
		};
		const orderData: any = await OrderService.createOrder(createOrderPayload);
		const { data, error } = orderData;
		if (data) {
			const { unAvailableCart, invalidCart, url: paymentUrl } = data;
			//Invalid Cart check
			if (invalidCart) {
				handleInvalidCart(data);
			//Soldout items check
			} else if (unAvailableCart) {
				handleUnavailableCart(data);
			} else {
				handleCheckout(paymentUrl);
			}
			showOrderPickupTimeModal(false);
			setCreateOrderLoading(false);
		}
		if (error) {
			//Show Error Message
			// setCreatOrderError(error);
			showOrderPickupTimeModal(false);
			showErrorModal(true);
			setCreateOrderLoading(false);
		}
	}

	function handleUnavailableCart(response: any) {
		let preText = "Looks like ",
			message = "",
			postText = "not available in your cart. Please adjust your cart accordingly";

		const { unavailableIngredients } = response;
		if (unavailableIngredients.length) {
			if (unavailableIngredients.length === 1) postText = " is " + postText;
			else postText = " are " + postText;

			for (const index in unavailableIngredients) {
				const ingredientId = unavailableIngredients[index];
				if (!ingredientDetails?.[ingredientId]) break;
				const { name } = ingredientDetails?.[ingredientId];

				message += name;

				if (parseInt(index) !== unavailableIngredients.length - 1) {
					message += ", ";
				}
			}

			message += postText;
		} else {
			message = preText + "some items are " + postText;
		}

		setUnavailableCartMessage(message);
		showUnavailableCart(true);
	}

	function handleInvalidCart(data: any) {
		const { discardedCart, newCart, invalidCoupons } = data;
		let message: string = "",
			hasMultipleDiscardedItems = false,
			hasMultipleInvalidCoupons = false,
			couponsPreText: string = "The coupon",
			couponsListText: string = "",
			couponsPostText = "invalid in your cart.";

		if (discardedCart?.cartItems?.length && invalidCoupons?.length) {
			for (const cartItem of discardedCart.cartItems) {
				const { title } = cartItem;
				if (!message.includes(title)) {
					if (message.length) {
						message += ",";
						hasMultipleDiscardedItems = false;
					}
					message += `${title}`;
				}
			}

			message += " in your cart ";
			message += hasMultipleDiscardedItems ? "are " : "is ";
			message += "unavailable. ";

			for (const coupon of invalidCoupons) {
				const { offerCode, title } = coupon;
				if (couponsListText.length) {
					hasMultipleInvalidCoupons = true;
					couponsListText += ` ,${title || offerCode}`;
				} else couponsListText += `${title || offerCode}`;
			}

			message += hasMultipleInvalidCoupons ? `${couponsPreText}s` : couponsPreText;
			message += ` ${couponsListText} `;
			message += hasMultipleInvalidCoupons ? `are ${couponsPostText}` : `is ${couponsPostText}`;
		} else if (discardedCart?.cartItems?.length) {
			discardedCart.cartItems.forEach((item: any) => {
				const { title } = item;
				if (!message.includes(title)) {
					if (message.length) {
						message += ", ";
						hasMultipleDiscardedItems = true;
					}

					message += `${title}`;
				}
			});

			message += " in your cart ";
			message += hasMultipleDiscardedItems ? "are " : "is ";
			message += "unavailable. Do you want to remove them?";
		} else if (invalidCoupons?.length) {
			for (const coupon of invalidCoupons) {
				const { offerCode, title } = coupon;
				if (couponsListText.length) {
					hasMultipleInvalidCoupons = true;
					couponsListText += ` ,${title || offerCode}`;
				} else couponsListText += `${title || offerCode}`;
			}

			message += hasMultipleInvalidCoupons ? `${couponsPreText}s` : couponsPreText;
			message += ` ${couponsListText} `;
			message += hasMultipleInvalidCoupons ? `are ${couponsPostText}` : `is ${couponsPostText}`;
		} else {
			//Might never be the case where there is invalid cart error and discardedCart is empty. Good to have a fallback just in case.
			message = "Some of the items in your cart are unavailable. Do you want to update your Cart?";
		}

		setInvalidCartMessage(message);
		setRectifiedCart(newCart);
		showInvalidCartModal(true);
	}

	async function rectifyCart() {
		setButtonLoading(true);
		const response = await OrderService.addToCart({ cart: recitifiedCart }, xookId);
		const { data, error } = response;
		if (data) {
			const { newCart, discardedCart } = data;
			let showDiscardedItemsError = false;

			if (discardedCart?.cartItems?.length) {
				//Show Error
				showDiscardedItemsError = true;
			}

			//Validate Cart on every change
			const { isCartValid, invalidCartItems } = validateCartItems({
				cartItems: newCart.cartItems,
				recipesMap,
				availableItems: initialInventory,
			});
			//Filter out valid items
			const calculateOnlyFor = newCart.cartItems.filter((cartItem: any, index: any) => !invalidCartItems.includes(index + ""));
			//Calculate inventory for only valid items.
			const { quantityRequired } = calculateInventory({ cartPayload: { cartItems: calculateOnlyFor }, recipesMap });
			//Update inventory accordingly
			updateIngrdientQuantity({ inventoryPayload: quantityRequired, mode: INVENTORY_UPDATE_ACTION.REMOVE_FROM_INITIAL });

			let cartUpdatedPayload = { ...newCart, invalidCartItems, isCartValid, showDiscardedItemsError, discardedCart };
			setCart(cartUpdatedPayload);

			setButtonLoading(false);

			showInvalidCartModal(false);
		}
		if (error) {
			ToastService.showToast("Could not update cart!");
			setInvalidCartMessage("");
			setRectifiedCart(null);
			showInvalidCartModal(false);
			setButtonLoading(false);
		}
	}

	return (
		<Page padding={"0 1rem 5rem 1rem"}>
			<PageHeader>
				<BackButton to={`/kiosk/${xookId || kioskId}`}>
					<BackButtonImg src={chevronBackOutline} />
				</BackButton>
				<PageTitle>Cart</PageTitle>
				<RestoName>Kiosk ID : {xookId || kioskId}</RestoName>
			</PageHeader>
			<PaddedElement />
			{!error && !loading && (
				<>
					{renderCartItems()}
					<SmallPaddedElement />
					{renderActiveCoupons()}
					<SmallPaddedElement />
					{renderBilling()}
				</>
			)}
			{!error && !loading && cartItems?.length ? (
				<>
					<SmallPaddedElement />
					<Header>Note</Header>
					<InfoCard>
						<SecondaryTextBright>To maximize flavor, your bowl contains fresh, ready-to-eat ingredients that are not cooked. We handle all items with the highest safety standards.</SecondaryTextBright>
					</InfoCard>
				</>
			) : ""}
			{error && !loading && <ErrorComponent code={errorCode} />}
			{loading && (
				<Center>
					<IonSpinner name="dots" color={"#F2F2F2"}></IonSpinner>
				</Center>
			)}
			{componentsLoading.length ? <ModalOverlay /> : ""}
			{itemsCount > 0 && !loading && !error ? (
				<BottomCTA onClick={getOrderStartTime} loading={buttonLoading} customCTAstyles={{ justifyContent: 'space-between' }} >
					<Row jContent="none" gap="0.5rem" width="auto" >
						<CheckoutItemCount>{itemsCount > 1 ? `${itemsCount} Items` : `${itemsCount} Item`}</CheckoutItemCount>
						<CheckoutSeperator />
						<CheckoutPrice>
							{currency}
							{uptilTwoDecimalPlaces(finalCartPrice)}
						</CheckoutPrice>
					</Row>
					<ProceedText>Proceed to Pay</ProceedText>
				</BottomCTA>
			) : (
				""
			)}
            <OrderPickupTimeModal
                isOpen={orderPickupTimeModal}
                data={orderPickupData}
                primaryButtonLoading={createOrderLoading}
                onCancel={() => {
                    showOrderPickupTimeModal(false);
                    setCreatOrderError("");
                }}
                onConfirm={() => {
                    createOrder();
                }}
            />
			{unAvailableCart && (
				<ModalOverlay>
					<Modal>
						<ModalHeader>Oops!!!</ModalHeader>
						<ModalSubtitle>{unavailableCartMessage}</ModalSubtitle>
						<ModalButtonGroup>
							<ModalSecondaryButton
								onClick={() => {
									setUnavailableCartMessage("");
									showUnavailableCart(false);
								}}>
								OK
							</ModalSecondaryButton>
						</ModalButtonGroup>
					</Modal>
				</ModalOverlay>
			)}
			{invalidCartModal && (
				<ModalOverlay>
					<Modal>
						<ModalHeader>Oops!!!</ModalHeader>
						<ModalSubtitle>{invalidCartMessage}</ModalSubtitle>
						<ModalButtonGroup>
							<ModalSecondaryButton
								disabled={buttonLoading}
								onClick={() => {
									showInvalidCartModal(false);
								}}>
								CANCEL
							</ModalSecondaryButton>
							<ModalPrimaryButton disabled={buttonLoading} onClick={rectifyCart}>
								{buttonLoading ? <IonSpinner name="dots" color={"#000"} /> : "REMOVE ITEMS"}
							</ModalPrimaryButton>
						</ModalButtonGroup>
					</Modal>
				</ModalOverlay>
			)}
			{showDiscardedItemsError && (
				<ModalOverlay>
					<Modal>
						<ModalHeader>Oops!!!</ModalHeader>
						<ModalSubtitle>Some of the items in your cart are invalid! We've removed those items from your cart.</ModalSubtitle>
						<ModalButtonGroup>
							<ModalPrimaryButton
								onClick={() => {
									softUpdateCart({ showDiscardedItemsError: false });
								}}>
								OK
							</ModalPrimaryButton>
						</ModalButtonGroup>
					</Modal>
				</ModalOverlay>
			)}
			{showInventoryErrorModal && (
				<ModalOverlay>
					<Modal>
						<ModalHeader>Oops!!!</ModalHeader>
						<ModalSubtitle>
							We regret to inform you that we currently do not have enough stock to fulfill your request. Please consider
							adjusting the quantity or try again later.
						</ModalSubtitle>
						<ModalButtonGroup>
							<ModalPrimaryButton
								onClick={() => {
									setInventoryErrorModal(false);
								}}>
								OK
							</ModalPrimaryButton>
						</ModalButtonGroup>
					</Modal>
				</ModalOverlay>
			)}
			{errorModal && (
				<ModalOverlay>
					<Modal>
						<ModalHeader>Oops!!!</ModalHeader>
						<ModalSubtitle>Something went wrong!</ModalSubtitle>
						<ModalButtonGroup>
							<ModalSecondaryButton
								disabled={createOrderLoading}
								onClick={() => {
									showErrorModal(false);
								}}>
								CANCEL
							</ModalSecondaryButton>
							<ModalPrimaryButton
								loading={createOrderLoading}
								onClick={() => {
									createOrder();
								}}>
								TRY AGAIN
							</ModalPrimaryButton>
						</ModalButtonGroup>
					</Modal>
				</ModalOverlay>
			)}
		</Page>
	);
};

//Redux mapping
const mapStateToProps = (state: any) => {
	const { Xook, Cart, Food, Inventory, User } = state;
	return { Xook, Cart, Food, Inventory, User };
};

const mapDispatchToProps = (dispatch: any) => ({
	...bindActionCreators(
		{
			...XookActions,
			...FoodActions,
			...CartActions,
			setMiscDishData,
			setUserData,
			setInitalInventory,
			updateIngrdientQuantity,
		},
		dispatch
	),
});

export default connect(mapStateToProps, mapDispatchToProps)(withNav(Cart));
